import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import pure from "recompose/pure";
import Typography from "@material-ui/core/Typography";

const sanitizeRestProps = ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  i18nKey,
  referenceResource,
  parentResource,
  sortable,
  sortBy,
  source,
  textAlign,
  translateChoice,
  fullWidth,
  searchKeys,
  pageSize,
  ...rest
}) => rest;

const LinkField = ({ className, source, addLabel, record = {}, onClick, ...rest }) => (
  <Typography
    component="span"
    className={addLabel ? "" : className}
    style={{ color: "blue", cursor: "pointer" }}
    onClick={_ => onClick && onClick(record)}
    {...sanitizeRestProps(rest)}
  >
    {get(record, source) === null || get(record, source) === undefined ? "-" : get(record, source)}
  </Typography>
);

LinkField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired
};

const PureLinkField = pure(LinkField);

PureLinkField.defaultProps = {
  addLabel: true
};

export default PureLinkField;
